import React from 'react';
import { useHistory } from 'react-router-dom';
import type { GetPortalAnsweringConfigResponse } from '@/app-package';
import AppointmentDeskPage from '../AppointmentDeskPage';

type LiveAppointmentDeskProps = {
  portalAnsweringConfig?: GetPortalAnsweringConfigResponse;
};

const LiveAppointmentDesk: React.FunctionComponent<
  LiveAppointmentDeskProps
> = ({ portalAnsweringConfig }) => {
  const history = useHistory();
  return (
    <AppointmentDeskPage
      portalConfig={portalAnsweringConfig}
      subscriptionType="org"
      billingRedirection={() => history.push('/billing')}
    />
  );
};

export default LiveAppointmentDesk;
